import { Detail } from "@dna/react";
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import { Facilities } from "../../services/medicationmanagement/facilities/FacilitiesApi";
import { Organization } from "../../services/medicationmanagement/organization/OrganizationApi";
import MenuItem from '@material-ui/core/MenuItem';
import { OrganizationAndFacilityType } from "./resident-filter/ResidentFilterReducer";
import { NonMandatory } from "../common";

const useStyles = makeStyles(() => ({
    root: {
        fontFamily: "Source Sans Pro",
        '&:hover': {
            backgroundColor: "#e1e1e1",
            cursor: "default",
        },
        paddingLeft: 20
    },
    menuitem: {
        fontFamily: "Source Sans Pro",
        '&:hover': {
            backgroundColor: "#e1e1e1",
            cursor: "default",
        }, 
        paddingLeft: 40
    }
}));

const menuitemStyle = {
    backgroundColor: "#008381", color: "white", fontStyle: "Source Sans Pro"
};



class MenuItemValue{
    constructor(private type:OrganizationAndFacilityType,private id:NonMandatory<string>){
        
    }

    get value(){
        switch (this.type) {
            case OrganizationAndFacilityType.All:
                return 'All';
            case OrganizationAndFacilityType.Facility:
                return `Facility=${this.id}`;
            case OrganizationAndFacilityType.Organization:
                return `Organization=${this.id}`;
            default:
                return 'All';
        }
    }

    isEqualTo(item:MenuItemValue){
        return this.value == item.value;
    }
}


const constructFacilities = (organization: Organization, facility: Facilities[], menuItemState: MenuItemValue, classes: any) => {
    // Facility= || Organization= prefix is required because MenuItem does not name name params in order to identify the the GUID
    let sortedFacilities = facility.filter((x: Facilities) => x.organisationId === organization.id)
        .map((val: Facilities) => {
            let facilityValue = new MenuItemValue(OrganizationAndFacilityType.Facility,val.facilityId);
            return <MenuItem key={val.facilityId} className={classes.menuitem} value={facilityValue.value}  style={facilityValue.isEqualTo(menuItemState) ? menuitemStyle : {}}>
                {val.facilityName}
            </MenuItem>
        });
    let organisationValue = new MenuItemValue(OrganizationAndFacilityType.Organization,organization.id);
    return [<MenuItem key={organization.id} className={classes.root} value={organisationValue.value}  style={organisationValue.isEqualTo(menuItemState) ? menuitemStyle : {}}>{organization.name + ` (all facilities)`}</MenuItem>, ...sortedFacilities];
}

export default function ResidentOrganizationAndFacility(props: {
    onOrganizationFacilityChanged: (facilityType: OrganizationAndFacilityType, id: string|null) => void;
    facilityData: Facilities[];
    organizationData: Organization[];
    menuItemState: {type:OrganizationAndFacilityType,id:string|null};
}) {
    const classes = useStyles();

    const handleChange = (event: any) => {
        let targetValue = event?.target?.value.split('=');
        let facilityType = targetValue[0];
        let value = targetValue[1];

        // Return  Facilities[] based on user selection 
        if (facilityType === OrganizationAndFacilityType.Facility) {
            //let facilities = props.facilityData.filter((x: any) => x.facilityId === value)
            props.onOrganizationFacilityChanged(OrganizationAndFacilityType.Facility, value);
        } else if (facilityType === OrganizationAndFacilityType.All) {
            props.onOrganizationFacilityChanged(OrganizationAndFacilityType.All,null);
        } else {
            props.onOrganizationFacilityChanged(OrganizationAndFacilityType.Organization, value);
        }
    };

    let selectedItem = new MenuItemValue(props.menuItemState.type,props.menuItemState.id);
    return (<>
        <Detail
            css={{
                color: "muted"
            }}
            level="small"
        >
            Organisations and facilities
        </Detail>

        <Select onChange={handleChange}
            defaultValue="" id="grouped-select" value={selectedItem.value}>
            <MenuItem selected value={"All"} className={classes.root}  style={props.menuItemState.type === OrganizationAndFacilityType.All ? menuitemStyle : {}}>{"All organisations and facilities"}</MenuItem>
            {props.organizationData.map((val: any) => {
                return constructFacilities(val, props.facilityData, selectedItem, classes)
            }).flatMap((res: any) => res)
            }
        </Select>
    </>
    );
};